import { Stack, Button, TeachersModal, Anchor, UserInfo } from 'components'
import { useTranslation } from 'react-i18next'
import { MainTeacherBlockProps } from './interfaces'
import { useDisclosure, useFeatureToggle } from 'hooks'
import { isEmpty } from 'lodash'

export const MainTeacherBlock = ({ teachers, mainTeacher, hideRole }: MainTeacherBlockProps) => {
  const { t } = useTranslation()
  const isArc = useFeatureToggle('arc-mosaico-project')
  const [openedTeachersModal, { open: openTeachersModal, close: closeTeachersModal }] = useDisclosure(false)

  const userInfo = (
    <UserInfo
      userName={mainTeacher.name}
      image={mainTeacher.avatar || ''}
      role={hideRole ? undefined : mainTeacher.educatorRole}
    />
  )

  return (
    <>
      {teachers !== null && mainTeacher.id !== '' && (
        <TeachersModal
          teachers={teachers}
          mainTeacherID={mainTeacher.id}
          opened={openedTeachersModal}
          onClose={closeTeachersModal}
          hideRole={hideRole}
        />
      )}
      <Stack spacing='xs'>
        {isArc ? userInfo : <Anchor href={mainTeacher.link}>{userInfo}</Anchor>}
{!isEmpty(teachers) && (
          <Button size='sm' variant='default' onClick={openTeachersModal}>
            {t('projects_show_teamModal_button')}
          </Button>
        )}
      </Stack>
    </>
  )
}
